<template>
    <div>
        <div class="root">
            <router-view></router-view>
            <notifications group="main" />
        </div>
        <vue-progress-bar></vue-progress-bar>
    </div>
</template>
<script>
export default {
    mounted () {
        this.$Progress.finish()
    },
    created () {
        this.$Progress.start()
        this.$router.beforeEach((to, from, next) => {
            if (to.meta.progress !== undefined) {
                let meta = to.meta.progress
                this.$Progress.parseMeta(meta)
            }
            this.$Progress.start()
            next();
        })

        this.$router.afterEach((to, from) => {
            const el = document.body;
            el.classList.remove("modal-open");
            const backdrop = document.getElementsByClassName("modal-backdrop")
            while(backdrop.length > 0){
                backdrop[0].parentNode.removeChild(backdrop[0]);
            }
            el.removeAttribute("style")
            this.$Progress.finish()
        })
    }
}
</script>

<style scoped>
@media only screen and (min-width: 768px) {
    .root {
        margin: 0 20%;
    }
}
</style>
